module.exports = __webpack_public_path__ + "img/d1.4f997830.jpg";